<template>
  <f-dashboard-content-layout>
    <template #dashboard-content-side>
      <f-dashboard-content-nav
        v-for="currentNav in currentNavs" 
        :key="currentNav.title"
        :links="currentNav.links"
      >
        <template #title>
          <h6>
            <i :class="currentNav.icon"></i>
            <small>{{ currentNav.title }}</small>
          </h6>
        </template>
      </f-dashboard-content-nav>
    </template>

    <router-view></router-view>
  </f-dashboard-content-layout>
</template>

<script>
  import { computed, watch } from 'vue'
  import { useStore } from '@freebe/sdk/store'
  import useRoles from '@composables/use-roles'
  import router from '@core/router'
  
  export default {
    async setup () {
      const { checkPermissions } = useRoles()

      if (!checkPermissions('partners:find')) {
        router.replace({ name: 'home' })
      }

      const partnerId = computed(() => router.currentRoute.value.params.partner_id)

      const partnerNavs = computed(() => [{
        title: 'Partenaire',
        icon: 'uil uil-user',
        links: [{
          name: 'Infos',
          to: { 
            name: 'partner-profile',
            params: {
              partner_id: partnerId.value,
            }
          }
        }, {
          name: 'Codes',
          permissions: ['freebe/pricing/codes:find'],
          to: { 
            name: 'partner-codes',
            params: {
              partner_id: partnerId.value,
            }
          }
        }, {
          name: 'Cashbacks',
          permissions: ['partners/cashbacks:find'],
          to: { 
            name: 'partner-cashbacks',
            params: {
              partner_id: partnerId.value,
            }
          }
        }]
      }])

      const listNavs = [{
        title: 'Users',
        icon: 'uil uil-user',
        links: [{
          name: 'Partenaires',
          to: { 
            name: 'partners-list',
          },
          exact: true,
        }]
      }]

      function hasPermissions (permissions) {
        for (var i = 0; i < permissions.length; i++) {
          if (!checkPermissions(permissions[i])) {
            return false
          }
        }

        return true
      }

      const currentNavs = computed(() => {
        const currentNavs = partnerId.value ? partnerNavs.value : listNavs
        return currentNavs.filter(route => {
          return route.links.permissions?.length ? hasPermissions(route.permissions) : true
        })
      })

      return {
        currentNavs,
      }
    },
  }
</script>
